import FormLabelGroup, {
  FormLabelGroupProps,
} from '@appfolio/react-gears/lib/components/FormLabelGroup';
import classNames from 'classnames';
import React from 'react';
import HighPrecisionPercentInput, {
  PercentInputProps,
} from '../inputs/HighPrecisionPercentInput';

export type HighPrecisionPercentFieldProps = FormLabelGroupProps &
  PercentInputProps;

export default function HighPrecisionPercentField({
  label,
  required,
  hint,
  rowClassName,
  validate,
  initialValue,
  feedback,
  tableField,
  ...props
}: HighPrecisionPercentFieldProps) {
  return (
    <FormLabelGroup
      stacked
      label={label}
      required={required}
      hint={hint}
      inputId={props.id}
      rowClassName={classNames(rowClassName, { 'no-gutters mb-0': tableField })}
      feedback={feedback}
    >
      <HighPrecisionPercentInput {...props} />
    </FormLabelGroup>
  );
}
